import usersListProjects from './modules/store'

export const modules = {
  usersListProjects
}



// WEBPACK FOOTER //
// ./src/store/Users/index.js